import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';

import './range-slider.scss';

export function RangeSlider({ className, onChange, ...props }) {
  const { defaultValue, min, max } = props;
  const [backgroundPercents, setBackgroundPercents] = useState(((defaultValue - min) * 100) / (max - min));

  const onRangeChange = useCallback(
    e => {
      const {
        target: { value },
      } = e;

      setBackgroundPercents(((value - min) * 100) / (max - min));
      onChange(e);
    },
    [onChange, min, max]
  );

  return (
    <input
      type="range"
      {...props}
      className={classnames('range-slider', className)}
      onChange={onRangeChange}
      style={{
        backgroundImage: `linear-gradient(90deg, #0069bf ${backgroundPercents}%, transparent ${backgroundPercents}%), linear-gradient(0deg, rgba(0, 0, 0, 0.43) 50%, transparent 50%)`,
      }}
    />
  );
}

RangeSlider.propTypes = {
  onChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  defaultValue: PropTypes.number,
};

RangeSlider.defaultProps = {
  onChange: noop,
  min: 0,
  max: 100,
  step: 1,
  defaultValue: 0,
};
